import { useState } from 'react'
import { Link } from 'gatsby'
import { Navigation } from '.'
import CookieConsent from '../cookieConsent/Cookieconsent'
import { Trans, useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import LazyLoad from 'react-lazy-load'

const Footer = () => {
  const { t } = useTranslation()
  const { language } = useI18next()
  return (
    <>
      <div className="viewport-bottom">
        {/* The footer at the very bottom of the screen */}

        <footer className="new_footer_area bg_color marketinglanding">
          <div className="marketinglanding">
            <div className="new_footer_top">
              <div className="container custom_container mob_footer">
                <div className="row mb-5">
                  <div id="nav_menu-3" className="widget footer-widget col-6 col-lg-2 col-sm-4 widget_nav_menu">
                    <div className="f_widget about-widget">
                      <h3 className="widget_title f-title f_500 t_color f_size_18 mb_40">
                        <Trans>Resource Center</Trans>
                      </h3>
                      <div className="menu-footer-3-company-container">
                        <ul id="menu-footer-3-company" className="menu">
                          {language === 'en-US' ? (
                            <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                              <a href="/product-updates/" className="nav-link">
                                Product Updates{' '}
                              </a>
                            </li>
                          ) : null}
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/en/blog/`)} className="nav-link" rel="noopener noreferrer" target="_blank">
                              Blog{' '}
                            </a>
                          </li>
                          {language === 'en-US' ? (
                            <>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                                <a href="/guides/" className="nav-link">
                                  Guides
                                </a>
                              </li>

                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                                <a href="/casestudy/" className="nav-link">
                                  Client Success Stories{' '}
                                </a>
                              </li>
                            </>
                          ) : null}
                          {/* <li id="menu-item-392" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389"><a href="https://www.vantagefit.io/corporate-wellness-glossary/" className="nav-link">Corporate Wellness Glossary </a></li> */}
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/faq/`)} className="nav-link">
                              <Trans>FAQ</Trans>
                            </a>
                          </li>
                          {language === 'en-US' ? (
                            <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                              <a href="/en/blog/podcasts/" className="nav-link" rel="noopener noreferer">
                                Podcasts{' '}
                              </a>
                            </li>
                          ) : null}
                          {language === 'en-US' ? (
                            <li
                              id="menu-item-611"
                              className="menu-item menu-item-type-post_type menu-item-object-page "
                            >
                              <a href={t(`/features/integrations/`)} className="nav-link">
                                <Trans>Integration</Trans>
                              </a>
                            </li>
                          ) : null}
                          {language === 'en-US' ? (
                            <li
                              id="menu-item-611"
                              className="menu-item menu-item-type-post_type menu-item-object-page "
                            >
                              <a href={t(`https://help.vantagefit.io/`)} className="nav-link" target="_blank">
                                <Trans>Help Center</Trans>
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div id="nav_menu-2" className="widget footer-widget col-6 col-lg-2 col-sm-4 widget_nav_menu">
                    <div className="f_widget about-widget">
                      <h3 className="widget_title f-title f_500 t_color f_size_18 mb_40">
                        <Trans>Company</Trans>
                      </h3>
                      <div className="menu-footer-2-solutions-container">
                        <ul id="menu-footer-3-company" className="menu">
                          <li
                            id="menu-item-587"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-586"
                          >
                            <a href={t(`/about-us/`)} className="nav-link">
                              <Trans>About Us</Trans>
                            </a>
                          </li>
                          <li
                            id="menu-item-586"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-586"
                          >
                            <a href={t(`/partners/`)} className="nav-link">
                              <Trans>Partners</Trans>
                            </a>
                          </li>
                          <li
                            id="menu-item-586"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-586"
                          >
                            <a href={t(`/partnership/`)} className="nav-link">
                              <Trans>Partnership</Trans>
                            </a>
                          </li>
                          {language === 'en-US' ? (
                            <li
                              id="menu-item-541"
                              className="menu-item menu-item-type-post_type_archive menu-item-object-career menu-item-541"
                            >
                              <a
                                href="https://www.vantagecircle.com/careers/"
                                className="nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Career{' '}
                              </a>
                            </li>
                          ) : null}
                          <li
                            id="menu-item-608"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-608"
                          >
                            <a href={t(`/contact-us/`)} className="nav-link">
                              <Trans>Contact Us</Trans>
                            </a>
                          </li>
                          {language === 'en-US' ? (
                            <li
                              id="menu-item-609"
                              className="menu-item menu-item-type-post_type menu-item-object-page "
                            >
                              <a href="/in-the-news/" className="nav-link">
                                News
                              </a>
                            </li>
                          ) : null}
                          <li id="menu-item-610" className="menu-item menu-item-type-post_type menu-item-object-page">
                            <a href={t(`/app-download/`)} className="nav-link">
                              <Trans>Download App</Trans>
                            </a>
                          </li>
                          {language === 'en-US' ? (
                            <>
                              <li
                                id="menu-item-611"
                                className="menu-item menu-item-type-post_type menu-item-object-page"
                              >
                                <a href={t(`/refer-vantage-fit/`)} className="nav-link">
                                  <Trans>Affiliate Program</Trans>
                                </a>
                              </li>
                            </>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    id="nav_menu-1"
                    className="widget footer-widget col-lg-3 col-md-4 widget_nav_menu col-sm-4 third-col-footer"
                  >
                    <div className="f_widget about-widget">
                      <h3 className="widget_title f-title f_500 t_color f_size_18 mb_40">
                        <Trans>Solutions</Trans>
                      </h3>
                      <div className="menu-footer-3-company-container">
                        <ul id="menu-footer-3-company" className="menu">
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/steps-challenge/`)} className="nav-link">
                              <Trans>Steps Challenge</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a
                              href={t(`/multi-activity-challenges/`)}
                              className="nav-link"
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <Trans>Multi-activity Challenges</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/team-challenges/`)} className="nav-link">
                              <Trans>Team Challenge</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/remote-team-wellness/`)} className="nav-link">
                              <Trans>Remote Team Wellness</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/global-employee-engagement/`)} className="nav-link">
                              <Trans>Global Employee Engagement</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a
                              href={t(`/mental-health-and-wellbeing-challenges/`)}
                              className="nav-link"
                              rel="noopener noreferer"
                            >
                              <Trans>Mental Health & Well-being</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/holistic-wellness-program/`)} className="nav-link" rel="noopener noreferer">
                              <Trans>Holistic Wellness Program</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/wellness-rewards-program/`)} className="nav-link" rel="noopener noreferer">
                              <Trans>Wellness Rewards Program</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a href={t(`/health-fitness-analytics/`)} className="nav-link" rel="noopener noreferer">
                              <Trans>Health & Fitness Analytics</Trans>
                            </a>
                          </li>
                          <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-389">
                            <a className="nav-link" rel="noopener noreferer" href={t(`/virtual-marathon/`)}>
                              <Trans>One Day Virtual Marathon</Trans>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    id="nav_menu-4"
                    className="widget footer-widget col-lg-5 col-md-12 widget_nav_menu col-sm-12 pl-md-5"
                  >
                    <div className="row f_widget about-widget f-title mb-0">
                      <div className="col-6 col-md-12 px-0">
                        <h3 className="hidden-xs widget_title f-title f_500 t_color f_size_18 mb_40">&nbsp;</h3>
                        <img
                          className="mb-5"
                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1725879741/VantageFit/2024/GPTW-updated.png"
                          alt="Certs"
                          width="356"
                          height="178"
                        />
                      </div>
                      <div className="col-6 col-md-12 px-0 mvw-store-icon pl-3 pl-lg-0">
                        <div className="">
                          <h3 className="widget_title f-title font-weight-light t_color f_size_18 mb-2">
                            <Trans>Download the app</Trans>
                          </h3>
                          <div className="justify-content-start align-content-center d-sm-flex mb-3 appstoreicon">
                            <a
                              href="https://play.google.com/store/apps/details?id=com.bargaintechnologies.vantagefit.v_fit"
                              target="_blank"
                            >
                              <img
                                className="img-responsive mr-2"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1683869449/VantageFit/2023/vfit-google-play.png"
                                width="200"
                                height="74"
                                alt="Google Play Store"
                              />
                            </a>
                            <a href="https://apps.apple.com/app/apple-store/id1393594182" target="_blank">
                              <img
                                className="img-responsive"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1683869448/VantageFit/2023/vfit-app-store.png"
                                width="200"
                                height="74"
                                alt="Apple App Store"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="social-icons">
                        <a href="https://in.linkedin.com/showcase/vantagefit" target="_blank" rel="noopener noreferrer">
                          <svg id="Bold" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z"
                              fill="#bcbcc7"
                            ></path>
                            <path d="m.396 7.977h4.976v16.023h-4.976z" fill="#bcbcc7"></path>
                            <path
                              d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z"
                              fill="#bcbcc7"
                            ></path>
                          </svg>
                        </a>
                        <a
                          href="https://www.facebook.com/Vantagefit-114318070217339/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg id="Bold" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z"
                              fill="#bcbcc7"
                            ></path>
                          </svg>
                        </a>
                        <a href="https://twitter.com/FitVantage" target="_blank" rel="noopener noreferrer">
                          <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 19.5699503 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="Holistic-Wellness-Tracker-Feature-Page"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fillRule="evenodd"
                            >
                              <g id="Group" fill="#bcbcc7" fillRule="nonzero">
                                <path
                                  d="M18.932133,0 L17.2057373,0 L10.879865,7.35319683 L5.82740935,0 L0,0 L7.64030431,11.1193359 L0,20 L1.72649364,20 L8.40677773,12.2347742 L13.742541,20 L19.5699503,20 L11.6463547,8.46863508 L18.932133,0 Z M9.28210899,11.2172998 L8.50798699,10.1100647 L2.34857343,1.29967302 L5.00036694,1.29967302 L9.9710854,8.40994153 L10.7452074,9.51717671 L17.2065527,18.7594282 L14.5547592,18.7594282 L9.28210899,11.2177239 L9.28210899,11.2172998 Z"
                                  id="Shape"
                                ></path>
                              </g>
                            </g>
                          </svg>
                        </a>
                        <a
                          href="https://www.youtube.com/channel/UCA_X-JntyyNU6rjeRQWHE2w/featured?sub_confirmation=1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg id="Bold" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="m23.469 5.929.03.196c-.29-1.029-1.073-1.823-2.068-2.112l-.021-.005c-1.871-.508-9.4-.508-9.4-.508s-7.51-.01-9.4.508c-1.014.294-1.798 1.088-2.083 2.096l-.005.021c-.699 3.651-.704 8.038.031 11.947l-.031-.198c.29 1.029 1.073 1.823 2.068 2.112l.021.005c1.869.509 9.4.509 9.4.509s7.509 0 9.4-.509c1.015-.294 1.799-1.088 2.084-2.096l.005-.021c.318-1.698.5-3.652.5-5.648 0-.073 0-.147-.001-.221.001-.068.001-.149.001-.23 0-1.997-.182-3.951-.531-5.846zm-13.861 9.722v-7.293l6.266 3.652z"
                              fill="#bcbcc7"
                            ></path>
                          </svg>
                        </a>
                        <a
                          href="https://open.spotify.com/show/3ogvh7sgeoBU15ehID3SFr"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg width="30px" height="20px" viewBox="0 0 30 20">
                            <g
                              id="Holistic-Wellness-Tracker-Feature-Page"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fillRule="evenodd"
                            >
                              <g id="Group" fill="#BCBCC7" fillRule="nonzero">
                                {' '}
                                <g id="Group" fill="#BCBCC7" fillRule="nonzero">
                                  <path
                                    d="M22.5193318,19.9993735 C22.3313894,19.9938601 22.1440494,19.9381132 21.9741784,19.8309077 C21.9723713,19.8309077 21.7549124,19.6906217 21.3085492,19.4474183 C20.8615836,19.2036023 20.2031829,18.8678959 19.3827421,18.5156492 C17.7436677,17.806255 15.4492045,17.020898 12.8848753,16.7194974 C12.0975654,16.6276069 11.3397721,16.5712475 10.6151096,16.5473559 C7.35623699,16.4383126 4.79491969,16.931458 3.75099615,17.1752739 C3.40161609,17.2567501 3.24078078,17.306371 3.24017841,17.306371 C2.65888226,17.4797376 2.05047905,17.139743 1.87940329,16.5491938 C1.71013467,15.9574193 2.04264811,15.3374651 2.62334187,15.1647111 C2.69743454,15.14327 6.00148567,14.1637179 10.6843833,14.3174812 C11.4650671,14.3444358 12.2861102,14.4038583 13.1342604,14.5037126 C18.8237341,15.1806388 23.0584614,17.8975328 23.1367707,17.9385772 C23.6512028,18.2663198 23.8066166,18.9548855 23.484946,19.4762106 C23.2717037,19.8266195 22.897626,20.0122382 22.5193318,19.9993735 L22.5193318,19.9993735 Z M26.5082883,13.4206306 C26.2396271,13.8561912 25.7733854,14.0902055 25.3005176,14.0736653 C25.0655896,14.0657014 24.831264,13.9958647 24.6192264,13.8610921 C24.6180217,13.8629298 24.5698314,13.8292367 24.4403198,13.7526613 C24.3096035,13.6754734 24.1132277,13.5621418 23.8578189,13.423081 C23.3433869,13.1425088 22.5892078,12.7565689 21.6440745,12.349188 C19.7586269,11.5338134 17.1196027,10.6332871 14.1715578,10.2877791 C13.2691934,10.1811861 12.3963456,10.118088 11.5620501,10.0905209 C7.81223822,9.96432472 4.86479571,10.5309824 3.66666304,10.8115546 C3.2666831,10.9058955 3.08536689,10.9598045 3.08416213,10.9616423 C2.35829493,11.1760533 1.59568258,10.7521321 1.38364502,10.0127203 C1.17040271,9.27269603 1.58664689,8.49775329 2.31432123,8.2845675 C2.40648529,8.25577512 6.23038985,7.12307228 11.6505998,7.30317755 C12.554169,7.3331951 13.5023142,7.40058142 14.4847951,7.51697597 C21.0772354,8.30233296 25.9781944,11.4431482 26.0757799,11.4988951 C26.7161092,11.909339 26.9112802,12.768821 26.5082883,13.4206306 L26.5082883,13.4206306 Z M29.7490896,7.28173644 C29.4256118,7.80489936 28.8641943,8.0842463 28.2985599,8.0652556 C28.0184535,8.05606656 27.7359376,7.97336516 27.4823359,7.81041278 C27.4823359,7.81041278 27.4233027,7.7724314 27.2702983,7.68115356 C27.1184987,7.59171353 26.8877874,7.45755349 26.5841882,7.2921507 C25.9793992,6.96440812 25.0896847,6.51046934 23.9764876,6.02896343 C21.7537075,5.06901462 18.6448274,4.00614852 15.1733147,3.59876756 C14.1083079,3.47379656 13.0788415,3.40028421 12.0969631,3.36842886 C6.94240233,3.19322442 3.07512644,4.12989432 2.26372136,4.34859356 C2.14806451,4.37922371 2.10710271,4.39147577 2.10710271,4.39147577 C1.23545969,4.65060681 0.322252483,4.14092117 0.0668436062,3.25509731 C-0.188565262,2.36804825 0.310204898,1.43750439 1.18365506,1.17837334 C1.29449287,1.14774319 5.8075195,-0.190181632 12.2041866,0.0230041979 C13.2710005,0.057922562 14.3890167,0.136335737 15.5485972,0.273558797 C23.332544,1.20165225 29.1111698,4.90728744 29.2286338,4.97406116 C29.9978723,5.46414352 30.2309931,6.49882988 29.7490896,7.28173644 Z"
                                    id="Shape"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 widget_text f_widget about-widget">
                    <div className="textwidget custom-html-widget">
                      <p>
                        <Trans>Powered by</Trans> <br />
                        <a href="https://www.vantagecircle.com/" target="_blank" rel="noopener">
                          <img
                            width="255"
                            height="37"
                            alt="Vantage Circle"
                            className="lozad"
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1708082285/VantageFit/2023/vclogo-255.png"
                            data-loaded="true"
                          />
                        </a>
                      </p>
                      {/* <p>Collaborate with us to provide your employees an engaging and rewarding experience.</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer_bottom">
            <div className="container">
              <div className="row col-12 align-items-center">
                <div className="col-lg-6 col-sm-7 col-md-6">
                  <p>
                    © Vantage Circle. {new Date().getFullYear()} <Trans>All rights reserved.</Trans>
                  </p>
                </div>
                <div className="col-lg-6 col-sm-5 text-right col-md-6">
                  <p>
                    <a
                      href={t(`https://www.vantagecircle.com/terms-conditions/`)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans>Terms and Conditions</Trans>
                    </a>
                    &nbsp; | &nbsp;
                    <a
                      href="https://api.vantagecircle.com/vantagefit/api/v1/tnc/355?isPrivacy=true"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans>Privacy Policy</Trans>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <CookieConsent />
    </>
  )
}

export default Footer
